// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .item[data-v-1c2a3381] {\n  cursor: pointer;\n}\n.level[data-v-1c2a3381] {\n  line-height: 24px;\n  list-style-type: dot;\n}\n[dir=ltr] .level[data-v-1c2a3381] {\n  padding-left: 16px;\n  border-left: 1px gray solid;\n}\n[dir=rtl] .level[data-v-1c2a3381] {\n  padding-right: 16px;\n  border-right: 1px gray solid;\n}\n.bold[data-v-1c2a3381] {\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
